<template>
  <div id="app">
    <div class="user-list">
      <div v-for="(user,index) in userInfo.userRelList">
        <div v-if="user.status > 0 " class="user-simple">
          <div v-if="user.orders > 1 && overflag"  class="right-image">
            <img src="../../assets/img/VIP@2x.png" />
          </div>
          <div class="miyou">
              <img v-show="user.portrait != ''" :src="user.portrait" alt="">
              <img  v-show="user.portrait == ''" src="../../assets/img/default-info.png" >
          </div>
          <div class="miyounum">
            <span>{{ user.displayName }}</span>
          </div>
          <div class="miyoudian" @click="changePass(user.code,user.orders)">
            <span>修改密码</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      userInfo: {},
      validitydate: "",
      overflag:false,
    };
  },
  created: function() {
    //this.changeUserInfo();
  },
  mounted() {
    this.userInfo = this.getUserInfo;
    
  },
  watch: {
    getUserInfo: function(newVal, oldVal) {
      console.log(JSON.stringify("userInfo 被修改"));
      // console.log(JSON.stringify(newVal))
      // console.log(JSON.stringify(oldVal))
     
      this.userInfo = newVal;
      var validitydate = this.userInfo.validitydate;
      var timestamp = Date.parse(new Date());
      var validitydate=new Date(validitydate).getTime();
              console.log("是否过期： "+(validitydate - timestamp))

      console.log(JSON.stringify(" validitydate:"+validitydate+" \t timestamp:"+timestamp));
      if(validitydate - timestamp < 0){
        this.overflag = true;
      }

    }
  },
  methods: {
    setPass: function(num) {
      this.$router.push({ name: "setPass", params: { code: num } });
    },
    changePass: function(num,orders) {
      
      var validitydate = this.userInfo.validitydate;
      var timestamp = Date.parse(new Date());
      var validitydate=new Date(validitydate).getTime();
      console.log(JSON.stringify(" validitydate:"+validitydate+" \t timestamp:"+timestamp));

      //判断是否过   聊天号暂时无法使用，请先购买VIP
      var _this =this;
      if( orders != 1 && this.overflag){
          tips.toast(' 聊天号暂时无法使用，请先购买VIP');
          setTimeout(function () {
              _this.$router.push("pay");
          }, 1500);
       }else{
          this.$router.push({ name: "changePassConfirmApp", params: { code: num } });
        }


    },
    tovip: function() {
      this.$router.push("/vip");
    },
    toDown: function(num) {
      this.$router.push({ name: "userApplist", params: { code: num } });
    },
    changeUserInfo: function() {
      this.$axiosHttp({
        method: "POST",
        url: api.qml.getuserInfo,
        data: { flag: 1 }
      })
        .then(res => {
          if (res.code == 0) {
            if (res.result != null) {
              this.userInfo = res.result;
            } else {
              this.userInfo = this.getUserInfo;
            }
            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_USERLIST, res.result.userRelList);
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.user-list {
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
}
.user-list ul {
  width: 100%;
  height: auto;
}

.user-simple {
  width: 625px;
  height: 152px;
  background: rgba(29, 33, 75, 1);
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.21);
  list-style: none;
  margin: 0 auto;
  display: flex;
  margin: 46px auto 0 auto;
}

.miyou {
  width: 95px;
  height: 40px;
  margin: 56px 0 0 30px;
  top: 56px;
  left: 30px;
}
.miyou span {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
}

.miyounum {
  width: 180px;
  height: 50px;
  margin: 50px 0 0 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  text-align: left;
  
}
.miyounum span{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #F5C3A7;
  letter-spacing: -0.07px;
}
.unopen-color {
  color: rgba(134, 139, 164, 1);
}

.miyounum span {
  font-size: 42px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(245, 195, 167, 1);
  line-height: 50px;
    font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #F5C3A7;
  letter-spacing: -0.07px;
}

.miyoudian {
  width: 200px;
  height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  position: relative;
  top: 50px;
  right: 20px;
  border: none;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
}

.miyounum-div {
  width: 200px;
  height: 48px;
  border-radius: 24px;
  position: relative;
  top: 20px;
  right: 20px;
}

.miyoudian span {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
}

.right-image {
  width: 60px;
  height: 32px;
  background: rgba(29, 33, 75, 1);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.21);
  position: absolute;
  right: 58px;
}
.right-image img {
  width: 100%;
  height: 100%;
}
.unopen {
  width: 72px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(134, 139, 164, 1);
  line-height: 54px;
}

.user-open {
  width: 100%;
  height: 52px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  border-radius: 24px;
  border: none;
}
.user-simple-log {
  width: 72px;
  height: 72px;
  display: flex;
}
.user-simple-log img {
  width: 72px;
  height: 72px;
  border-radius: 55px;
}

.user-simple-pass {
  width: 616px;
  height: 152px;
  background: rgba(29, 33, 75, 1);
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.21);
  list-style: none;
  margin: 46px auto 0 auto;
  display: flex;
}

.user-simple-logo {
  width: 72px;
  height: 72px;
  border-radius: 55px;
  left: 34px;
  margin: 40px 22px 0 34px;
}

.user-simple-logo img {
  width: 72px;
  height: 72px;
  border-radius: 55px;
}

.user-simple-info {
  flex: 1;
}
.user-simple-info p {
  text-align: inherit;
}
.user-simple-info-name {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  margin: 35px 0px 0px 0px;
  text-align: left;
  overflow: hidden;
}

.user-simple-info .content {
  width: 72px;
  height: 30px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 30px;
  float: left;
}
.user-simple-info .num {
  width: 160px;
  height: 48px;
  border-radius: 24px;
  opacity: 0.16269999999999998;
  border: 1px solid rgba(229, 229, 229, 1);
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 48px;
  float: left;

  margin: 0px 0px 22px 6px;
}
.user-simple-info .num span {
  color: #f5c3a7;
}

.user-simple-button {
  width: 184px;
  height: 52px;
  background: url("../../assets/img/miyoudian@2x.png");
  background-size: 100% 100%;
  border-radius: 24px;
  border: 4px solid rgba(255, 227, 205, 1);
  margin: 46px 24px 34px 0px;
}
.user-simple-button span {
  height: 52px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 52px;
}

/* .miyoudian:active, */
.user-simple-button:active,
.user-open:active {
  background: rgba(216, 216, 216, 1);
}

.miyou img{
  width: 80px;
  height: 80px;
  margin-top: -20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/centerUserListpw.vue